const login = {
  subtitleTop: 'Injection Molding Monitoring System',
  systemTitle: '사출 통합 관제 시스템',
  adminLogin: '관리자 로그인',
  email: '이메일',
  password: '비밀번호',
  rememberMe: '로그인 상태 유지',
  submit: '로그인',
  submitting: '로그인 중...',
  forgotPassword: '비밀번호 찾기',
  forgotPasswordAlert: '비밀번호 찾기는 관리자에게 문의하세요.\n\n관리자 이메일: skm@seoro.ai.kr',
  contactAdminAlert: '계정 생성은 관리자에게 문의하세요.\n\n관리자 이메일: skm@seoro.ai.kr',
  noAccount: '계정이 없으신가요?',
  contactAdmin: '관리자에게 문의',
  loginFailed: '로그인에 실패했습니다',
  serverError: '서버와 연결할 수 없습니다',
};

export default login;
